const config = [
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '项目概况',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '成交合同信息',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
    }
  },
  methods: {
    getData() {
      this.$request.post(`/transformToAfter/app/home/htggDetail`, {
        guid: this.$route.query.ggGuid,
      }, { showLoading: true }).then((res) => {
        this.config[1].options.data = {
          '标段/包名称': res.data.bdName,
          '标段/包编号': res.data.bdBh,
          '项目类型': getProjectTypeName(res.data.xmLeiXing),
          '采购方式': getPurchaseTypeName(res.data.zbFangShi),
          '项目经理': res.data.projectManagerName,
          '联系电话': res.data.lianXiRenPhone,
        }
        this.config[3].options.data = {
          '履约情况': res.data.lvYueQingKuang,
        }
      })
    },
  },
}

module.exports = {
  config,
  mixin,
}
